var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnap = function SvgSnap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M70 11 59 0C46.696 15.38 23.304 15.38 11 0L0 11c15.38 12.304 15.38 35.696 0 48l11 11c12.304-15.38 35.696-15.38 48 0l11-11c-15.38-12.304-15.38-35.696 0-48Z"
  })));
};
export default SvgSnap;